import { forwardRef, type Ref, type SVGProps } from "react";
const IconLocationArrowFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M29.7 4.216c.385-1.259-.905-2.377-2.096-1.818L4.28 13.349c-1.379.648-1.05 2.697.463 2.88l11.702 1.413 2.681 11.437c.354 1.508 2.475 1.58 2.928.098z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLocationArrowFilledSVG);
ForwardRef.displayName = "IconLocationArrowFilled";
export { ForwardRef as IconLocationArrowFilled };
